import React from 'react';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import { FilterPopover, ListPagination, ListPlaceholder, ListSearch } from '../components/lists/ListPageParts';
import { countActiveFilters } from '../utils/listFilters';
import SessionTable from '../features/sessions/list/components/SessionTable';
import SessionFilters from '../features/sessions/list/components/SessionFilters';
import { useSessionList } from '../features/sessions/list/hooks/useSessionList';
import '../features/sessions/list/styles/sessions.css';

export default function SessionsPage() {
  const {
    listAreaRef, items: sessions, loading, error, pagination,
    query, setQuery, filters, setFilter, clearFilters, sort, setSort, facets,
  } = useSessionList();
  const { total } = pagination;

  return (
    <div className="sessions-page">
      <div className="sessions-content">
        <div className="sessions-page-head">
          <h1>Sessions</h1>
          <span className="sessions-count">{total} {total === 1 ? 'session' : 'sessions'}</span>
        </div>

        <div className="sessions-toolbar">
          <ListSearch prefix="sessions" placeholder="Search title, file, event, user..." value={query} onChange={setQuery} />

          <select className="sessions-input sessions-sort" value={sort} onChange={(event) => setSort(event.target.value)}>
            <option value="newest">Newest</option>
            <option value="oldest">Oldest</option>
            <option value="az">A to Z</option>
            <option value="duration">Longest</option>
          </select>

          <FilterPopover
            prefix="sessions"
            activeCount={countActiveFilters(filters)}
            resetLabel="Clear all"
            onReset={clearFilters}
          >
            <SessionFilters filters={filters} setFilter={setFilter} facets={facets} />
          </FilterPopover>
        </div>

        <div className="sessions-list-area" ref={listAreaRef}>
          {loading ? (
            <ListPlaceholder prefix="sessions" isLoading title="Loading sessions..." detail="Fetching session list from the backend." />
          ) : error ? (
            <ListPlaceholder prefix="sessions" isError Icon={DocumentTextIcon} title="Sessions unavailable" detail={error} />
          ) : sessions.length === 0 ? (
            <ListPlaceholder prefix="sessions" Icon={DocumentTextIcon} title="No sessions match." detail="Clear search or try another status." />
          ) : (
            <SessionTable sessions={sessions} />
          )}
        </div>

        <div className="sessions-pagination-slot">
          {!loading && !error && sessions.length > 0 && <ListPagination prefix="sessions" {...pagination} />}
        </div>
      </div>
    </div>
  );
}
